export default defineNuxtRouteMiddleware(async () => {
    const host = useRequestHeaders().host;
    if (!host) return;

    const i18n = useNuxtApp().$i18n;
    const locales: string[] = i18n.locales.value.map(el => el.code);

    let language = host.split('.')[0]
    if (!locales.includes(language)) language = i18n.defaultLocale;
    await i18n.setLocale(language);
});